export enum FeatureFlagVariantKeys {
    SeasonalLogo = 'photo_seasonal_logo'
}
